import { create } from 'zustand';

interface ActivityStore {
  activeTime: number;
  isTracking: boolean;
  projectId: string | null;
  startTime: string | null;
  sessionProjectId: string | null;
  sessionId: string | null;
  isPaused: boolean;
  pausedAt: string | null;
  lastActivityAt: string | null;
  sections: Record<string, number>;
  currentSectionKey: string;
  setActiveTime: (time: number | ((t: number) => number)) => void;
  setIsTracking: (tracking: boolean) => void;
  setProjectId: (id: string | null) => void;
  setStartTime: (time: string | null) => void;
  setSessionProjectId: (id: string | null) => void;
  setSessionId: (id: string | null) => void;
  setIsPaused: (paused: boolean) => void;
  setPausedAt: (iso: string | null) => void;
  setLastActivityAt: (iso: string | null) => void;
  setCurrentSectionKey: (key: string) => void;
  incrementSectionSecond: (key: string) => void;
  resetSession: () => void;
}

const useTimerStore = create<ActivityStore>((set) => ({
  activeTime: 0,
  isTracking: false,
  projectId: null,
  startTime: null,
  sessionProjectId: null,
  sessionId: null,
  isPaused: false,
  pausedAt: null,
  lastActivityAt: null,
  sections: {},
  currentSectionKey: 'unknown',
  setActiveTime: (time) =>
    set((state) => ({
      activeTime: typeof time === 'function' ? time(state.activeTime) : time,
    })),
  setIsTracking: (tracking) => set({ isTracking: tracking }),
  setProjectId: (id) => set({ projectId: id }),
  setStartTime: (time) => set({ startTime: time }),
  setSessionProjectId: (id) => set({ sessionProjectId: id }),
  setSessionId: (id) => set({ sessionId: id }),
  setIsPaused: (paused) => set({ isPaused: paused }),
  setPausedAt: (iso) => set({ pausedAt: iso }),
  setLastActivityAt: (iso) => set({ lastActivityAt: iso }),
  setCurrentSectionKey: (key) => set({ currentSectionKey: key }),
  incrementSectionSecond: (key) =>
    set((state) => ({
      sections: {
        ...state.sections,
        [key]: (state.sections[key] ?? 0) + 1,
      },
    })),
  resetSession: () =>
    set({
      activeTime: 0,
      isTracking: false,
      startTime: null,
      sessionProjectId: null,
      sessionId: null,
      isPaused: false,
      pausedAt: null,
      lastActivityAt: null,
      sections: {},
      currentSectionKey: 'unknown',
    }),
}));

export default useTimerStore;
